const ITEMS = [
  "MOTOWN / SOUL",
  "90s & CONTEMPORARY R&B",
  "CONTEMPORARY TOP 40",
  "GOSPEL / INSPIRATIONAL",
  "POP/ROCK CLASSICS",
  "MUSICAL THEATRE",
];

export default function Marquee() {
  return (
    <div className="relative border-y border-white/10 bg-surface/60 py-6 overflow-hidden" data-testid="genre-marquee">
      <div className="marquee-track">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center shrink-0" aria-hidden={dup === 1}>
            {ITEMS.map((item, i) => (
              <span key={i} className="flex items-center">
                <span className="font-display font-extrabold uppercase text-2xl sm:text-4xl lg:text-5xl tracking-tight text-white/90 px-6">
                  {item}
                </span>
                <span className="h-2.5 w-2.5 rotate-45 bg-gradient-to-br from-hpink to-horange" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
